import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Space, Button, Tag, Tooltip } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { SearchOptions } from '../TableHelper'
import { Pagination } from 'components/Pagination'

type MappingColorListProps = BaseListComponentProps & {
  loading: boolean,
  mappingColors: any,
  pagination: any,
  filters: any | null,
  history?: any,

  loadMappingColors: (args: SearchRequest) => void,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingColorList extends ListComponent<MappingColorListProps> {

  static defaultProps = {
    loading: false,
    mappingColors: [],

    loadMappingColors: () => {}
  }

  tableColumns = [
    {
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority',
      sorter: (a: any, b: any) => a.priority - b.priority
    },
    {
      title: 'Type',
      dataIndex: 'type_key',
      key: 'type_key',
      sorter: (a: any, b: any) => a.type_key - b.type_key
    },
    {
      title: 'Direction',
      dataIndex: 'direction_key',
      key: 'direction_key',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.direction_key - b.direction_key
    },
    {
      title: 'Partner',
      dataIndex: 'partner_key',
      key: 'partner_key',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.partner_key - b.partner_key
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name - b.name,
      render: (value: any, record: any, index: number) => record.direction_key !== "INPUT" ? value : '-'
    },
    {
      title: 'External ID',
      dataIndex: 'external_id',
      key: 'external_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.external_id - b.external_id,
      render: (value: any, record: any, index: number) => record.direction_key !== "INPUT" ? value : <Tooltip title={record.json?.expression} children={<Tag children="EXPRESSION" />}/>
    },
    {
      title: 'Color',
      dataIndex: ['color_key'],
      key: 'color_key',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.color_key - b.color_key,
      render: (value: any, record: any, index: number) => record.direction_key !== "OUTPUT" ? value : <Tooltip title={record.json?.expression} children={<Tag children="EXPRESSION" />}/>
    },
    {
      title: 'Shelter',
      dataIndex: ['shelter', 'name'],
      key: 'shelter_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.shelter?.name - b.shelter?.name,
      render: (value: any, record: any, index: number) => record.shelter_id ? value : <Tag children="GLOBAL" />
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text: string, record: any) => (
        <Space size='middle'>
          <Link to={`color/${record.uuid}`} ref={(refs) => this.actionRefs.edit.push(refs)}>
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      )
    }
  ]

  componentDidUpdate(prevProps: any, prevState: any) {
    this.validateAccessPermissions()

    if (prevProps.filters !== this.props.filters) {
      this.load()
    }
  }
  
  protected load() {
    this.searchOptions = {
      search: {
        ...this.props.filters,
        shelter: {
          with: {
            _fields: ["id", "uuid", "name"]
          },
        },
      },
      options: {
        ...this.searchOptions.options,
        _force_ids: true,
        sort: ['shelter_id', '-priority']
      }
    }

    this.props.loadMappingColors(this.searchOptions)

    if (this.props.onLoad) {
      this.props.onLoad(this.searchOptions)
    }
  }

  render() {
    const { loading, pagination, mappingColors, loadMappingColors } = this.props

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={mappingColors}
          onChange={(pagination: any, filters: any, sorter: any) => this.handleTableChange(pagination, sorter, loadMappingColors)}
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={mappingColors?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadMappingColors)
          }
        />
      </>
    )
  }
}
